import { useEffect, useState } from "react";
import axios from "axios";
// import './App.css';
// import "bootstrap/dist/css/bootstrap.min.css";
// import "bootstrap/dist/js/bootstrap.min.js";
// import "jquery/dist/jquery.min.js";
// import "./assets/css/oldStyle.css";
// import "./assets/css/mainStyle.css";
import { NavTopMain } from "../components/navTop";
import { HeaderBanner } from "../components/banners";
import AboutHistory from "../components/aboutHistory/aboutHistory";
import PageFooter from "../components/footer";
// import TableStudentData from "./comp_ict/sample_api_2";
// import { ApiGetTest } from "./comp_ict/api_axios";

import AOS from "aos";
import "aos/dist/aos.css";

const showConsole = false;
const apiUrl = process.env.REACT_APP_API_URL;
const apiUrlBanners = `${apiUrl}banners/header/index.json`;

// import { createBrowserRouter, RouterProvider } from "react-router-dom";

export default function App() {
    const [bannerHeader, setBannerHeader] = useState([]);
    // const [bannerHeaderLoading, setBannerHeaderLoading] = useState(true);
    const [navMenuItem, setNavMenuItem] = useState([]);

    async function fetchNavMenuItem() {
        await axios
            .get(`${apiUrl}nav/index.json`)
            .then((res) => {
                setNavMenuItem(res.data);
            })
            .catch((error) => {
                console.error(`nav axios err: ${error}`);
            });
    }

    const fetchHeaderBanners = async () => {
        try {
            const result = await axios.get(apiUrlBanners);

            showConsole && console.log("api data: ", result.data);
            if (result.data.bannerHeader.length > 0) {
                setBannerHeader(result.data.bannerHeader);
            }
            // setBannerHeaderLoading(false);
        } catch (e) {
            console.error("Error: ", e);
            // setBannerHeaderLoading(false);
        }
    };

    useEffect(() => {
        console.clear();
        fetchHeaderBanners();
        fetchNavMenuItem();

        AOS.init();
    }, []);
    return (
        <>
            {/* <h1>arch 2024 version presented by React.</h1> */}
            <div id="contentHolder">
                {bannerHeader.length > 0 && (
                    <HeaderBanner data={bannerHeader} />
                )}
                {navMenuItem && <NavTopMain navMenuItem={navMenuItem} />}
                <section className='my-2 my-md-5 container-fluid bg-white p-2 p-md-4 rounded-3 shadow'>
                    <AboutHistory/>
                </section>
            </div>
            {navMenuItem && <PageFooter navMenuItem={navMenuItem} />}
        </>
    );
}
